import React, { FC } from 'react';
import styled, { useTheme } from 'styled-components';

interface AgreementBlockProps {
  x: number;
  y: number;
  width: number;
  height: number;
  value: string;
  bgColor: string;
}

const Block = styled.rect<{ bgColor: string }>`
  fill: ${({ bgColor }) => bgColor};
  rx: 4px;
  ry: 4px;
`;

const AgreementBlock: FC<AgreementBlockProps> = ({ x, y, width, height, value, bgColor }) => {
  const theme = useTheme();
  const circleDiameter = 8;
  const circleRadius = circleDiameter / 2;
  const gap = 2;

  const centerX = x + width / 2;
  const centerY = y + height / 2;

  const circle1Cx = centerX - circleRadius - gap / 2;
  const circle2Cx = centerX + circleRadius + gap / 2;

  let circles;
  if (value === 'disagreement') {
    circles = (
      <>
        <circle cx={circle1Cx} cy={centerY} r={circleRadius} fill={theme.colors.support.red[100]} />
        <circle cx={circle2Cx} cy={centerY} r={circleRadius} fill={theme.colors.support.red[100]} />
      </>
    );
  } else if (value === 'low') {
    circles = (
      <>
        <circle
          cx={circle1Cx + 2}
          cy={centerY}
          r={circleRadius}
          fill={theme.colors.accent.orange[70]}
        />
        <circle
          cx={circle2Cx - 2}
          cy={centerY}
          r={circleRadius * 1.5}
          fill={theme.colors.accent.orange[100]}
        />
      </>
    );
  } else if (value === 'moderate') {
    circles = (
      <>
        <circle
          cx={circle1Cx + 2}
          cy={centerY}
          r={circleRadius}
          fill={theme.colors.neutral.primary[50]}
        />
        <circle
          cx={circle2Cx - 2}
          cy={centerY}
          r={circleRadius * 1.5}
          fill={theme.colors.neutral.primary[30]}
        />
      </>
    );
  } else if (value === 'high') {
    circles = (
      <circle
        cx={centerX}
        cy={centerY}
        r={circleRadius * 1.5}
        fill={theme.colors.neutral.primary[30]}
      />
    );
  }

  return (
    <>
      <Block x={x} y={y} width={width} height={height} bgColor={bgColor} />
      {circles}
    </>
  );
};

export default AgreementBlock;
